import { useNavigate } from 'react-router-dom';

export const withNavigation = (Component) => {
  return function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
};
